import { ActionIcon, Badge, Button, Group, Loader, Modal, Tabs, Text } from '@mantine/core';
import { Tab } from '@mantine/core/lib/Tabs/Tab/Tab';
import { showNotification } from "@mantine/notifications";
import * as React from 'react';
import { FaSearch } from 'react-icons/fa';
import { useApp } from '../contexts/app.context';
import { SEARCH_CONTENTS_BY_KEYWORD, SEARCH_CONTENTS_SPECIFIC } from '../services/contents';
import InputField, { InputFieldTypes } from './input_field';
import { BadgeOrigin } from './theme_paper';

export default function SearchTheme({ type : typeProp = "specific", onChangeFocus } : {onChangeFocus? : (focus: boolean) => void, type: "specific" | "keyword"}){
  const [searchForm, setSearchForm] = React.useState({
    type: "",
    number: "",
    year: "",
  });
  const [type, setType] = React.useState("specific");
  const [searchText, setSearchText] = React.useState("");
  const [focusedSearch, setFocusedSearch] = React.useState(false);
  const [loadingSearch, setLoadingSearch] = React.useState({});
  const [searchResults, setSearchResults] = React.useState({});
  const activeFormKey = `${searchForm.type};${searchForm.number};${searchForm.year}`;

  const { openTheme } = useApp();

  const searchSpecific = () => {
    const key = activeFormKey;
    if(searchForm.type || searchForm.number || searchForm.type){
      setLoadingSearch(ls => ({...ls, [key]: true}))
      SEARCH_CONTENTS_SPECIFIC(searchForm)
      .then(({results}) => {
        setLoadingSearch(ls => ({...ls, [key]: false}))
        setSearchResults(sr => ({...sr, [key]: results}));
      })
      .catch(err => {
        setLoadingSearch(ls => ({...ls, [key]: false}))
        showNotification({title: "Ops.", message: err.message, color: 'red'})
      })      
    }
  }


  React.useEffect(() => {
    if(searchText && searchText.length > 1){
      const key = activeFormKey;
      setLoadingSearch(ls => ({...ls, [key]: true}))
      SEARCH_CONTENTS_BY_KEYWORD(searchText)
      .then(({results}) => {
        setLoadingSearch(ls => ({...ls, [key]: false}))
        setSearchResults(sr => ({...sr, [key]: results}));
      })
      .catch(err => {
        setLoadingSearch(ls => ({...ls, [key]: false}))
        showNotification({title: "Ops.", message: err.message, color: 'red'})
      })
    }
  }, [searchText])

  React.useEffect(() => {
    onChangeFocus && onChangeFocus(focusedSearch);
  }, [focusedSearch])

  React.useEffect(() => {
    setType(typeProp)
  }, [typeProp])

  return <>
    <ActionIcon
        style={{margin: '0 7px'}}
        onClick={() => setFocusedSearch(true)}
        variant="outline">
        <FaSearch />
      </ActionIcon>
  <Modal
    opened={focusedSearch}
    size="lg"
    onClose={() => { setFocusedSearch(false) }}
    trapFocus={false}
  >
    <Tabs value={type}>
      <Tabs.List position="center">
        <Tabs.Tab value="specific" onClick={(i) => setType("specific")}>Por número/ano</Tabs.Tab>
        <Tabs.Tab value="keyword" onClick={(i) => setType("keyword")}>Por palavra-chave</Tabs.Tab>
      </Tabs.List>

      <Tabs.Panel value="specific" pt="xs">
        <div style={{display: 'flex', padding: '0 10px', flexDirection: 'row', alignItems: 'center'}}>
          <InputField
            style={{ margin: '0 5px', width: 80 }}
            title=""
            placeholder="Sigla"
            value={searchForm.type}
            name="type"
            onChange={({type}) => setSearchForm(sf => ({...sf, type}))}
            type={InputFieldTypes.STRING}
          />
          <InputField
            style={{ margin: '0 5px', width: 100 }}
            title=""
            placeholder="Número"
            value={searchForm.number}
            name="number"
            onChange={({number}) => setSearchForm(sf => ({...sf, number}))}
            type={InputFieldTypes.STRING}
          />
          <InputField
            style={{ margin: '0 5px', width: 80 }}
            title=""
            placeholder="Ano"
            value={searchForm.year}
            name="year"
            onChange={({year}) => setSearchForm(sf => ({...sf, year}))}
            type={InputFieldTypes.STRING}
          />
          <Button onClick={searchSpecific}>
            <FaSearch />
          </Button>
        </div>
      </Tabs.Panel>
      <Tabs.Panel value="keyword" pt="xs">
        <div>
          <InputField
            style={{ margin: '0 20px', minWidth: 280 }}
            title=""
            icon={<FaSearch />}
            placeholder="Buscar pauta, assunto ou entidade"
            value={searchText}
            name="search"
            onChange={({search}) => setSearchText(search)}
            type={InputFieldTypes.STRING}
          />
        </div>
      </Tabs.Panel>
    </Tabs>
      <div>
        <Group mt="lg">
          {searchResults[activeFormKey] && <Text style={{flex: 1, margin: 0}}>Resultados</Text>}
          {activeFormKey && loadingSearch[activeFormKey] && <Loader />}
        </Group>
        {searchResults[activeFormKey] && searchResults[activeFormKey].length === 0 && <Text mt="md" size="sm">Nenhum resultado encontrado</Text>}
          {(searchResults[activeFormKey] || []).map(item => 
            <Button
              variant="subtle"
              mt="lg"
              style={{ display: 'block' }}
              fullWidth
              onClick={() => {
                openTheme(item)
                setFocusedSearch(false);
                setSearchText("")
              }}
              rightIcon={<BadgeOrigin origin={item.origin}/>}
            >{item.title}</Button>
          )}
        </div>
    </Modal>  
  </>
}